import React from 'react';
import { Select } from 'antd';
import { getYears } from "../../../../services/utils";
import { connect } from "react-redux";

const { Option } = Select;

const YearFilter = ({ year, handleYearChange, eventStatsFilter }) => {
  return (
    <Select
      style={{ width: 120 }}
      onChange={handleYearChange}
      value={year}
    >
      {getYears().filter(y => y != eventStatsFilter.year[0]).map((y) => (
        <Option key={y} value={y}>
          {y}
        </Option>
      ))}
    </Select>
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
});

export default connect(mapStateToProps)(YearFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/CompareStats/YearFilter.js